<app-main-container>
  <div class="w-full">
    <header class="py-6 flex w-full justify-content-center">
      <h2 class="text-center">Statistique du mois</h2>
    </header>
    <div class="flex flex-column w-full align-items-center justify-content-center
    md:flex-row md:justify-content-center md:flex-wrap md:gap-1 md:row-gap-1 md:p-1">

      <!-- Données prix vente/achat tout catégorie confondue -->
      <app-stacked-bar-chart class="md:w-5 h-28rem" [dataObservable$]="soldAndBuyProductPriceByMonth$" dataSymbol="€"></app-stacked-bar-chart>

      <!-- Données quantité vente/achat tout catégorie confondue -->
      <app-stacked-bar-chart class="md:w-5 h-28rem" [dataObservable$]="soldAndBuyProductQuantityByMonth$"  [yStepSize]=1></app-stacked-bar-chart>

    </div>

    <!--detail-->
    <div class="w-full">
      <p-tabView class="w-full">
        <p-tabPanel header="Détails des achats">
          <div class="flex flex-column w-full align-items-center justify-content-center
          md:flex-row">
            <!-- Données prix vente par catégorie et mois -->
            <app-doughnut-chart class="md:w-5 h-28rem" [dataObservable$]="buyProductPriceByCategoryAndMonth$" dataSymbol="€"></app-doughnut-chart>

           <!-- Données quantité achat par catégorie et mois-->
            <app-doughnut-chart class="md:w-5  h-28rem" [dataObservable$]="buyProductQuantityByCategoryAndMonth$"></app-doughnut-chart>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Détail des ventes">
          <div class="flex flex-column w-full align-items-center justify-content-center
          md:flex-row">
            <!-- Données prix achat par catégorie et mois-->
            <app-doughnut-chart class="md:w-5  h-28rem" [dataObservable$]="soldProductPriceByCategoryAndMonth$" dataSymbol="€"></app-doughnut-chart>

             <!-- Données quantité vente par catégorie et mois -->
            <app-doughnut-chart class="md:w-5  h-28rem" [dataObservable$]="soldProductQuantityByCategoryAndMonth$"></app-doughnut-chart>
          </div>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</app-main-container>
